import { BBPBaseService } from "./BBPBaseService";
export class BBPFrontendService extends BBPBaseService {
    firebaseAuth;
    constructor(url, firebaseAuth) {
        super(url, window.fetch.bind(window));
        this.firebaseAuth = firebaseAuth;
    }
    async getAuthHeaders() {
        const user = this.firebaseAuth.currentUser;
        if (!user) {
            return {};
        }
        const token = await user.getIdToken();
        return {
            Authorization: `Bearer ${token}`,
        };
    }
}
